// src/app/core/guards/invoicing.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the /invoicing section.
 *
 * Access is granted if the current user has any of:
 *   - invoicing.view / invoicing.view_all / invoicing.cancel / invoicing.reports
 *   - offers_policies.invoices.create
 * (admin.full_access bypasses all checks via PermissionService.has)
 */
export const invoicingGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewInvoicing(), '/dashboard');
};

/**
 * CanMatchFn — gates /invoicing/report (Raportet e faturave).
 * Requires invoicing.reports; the API answers 403 without it.
 */
export const invoicingReportGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewInvoiceReports(), '/invoicing');
};

/**
 * CanMatchFn — gates the /invoicing/create sub-route.
 *
 * View permission alone is not enough to create an invoice — backend
 * rejects (403) and FE must hide the page entirely. Defense-in-depth
 * pair to the in-component canCreateInvoice() check on submit.
 */
export const invoicingCreateGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canCreateInvoice(), '/invoicing');
};
